import React from "react"

import cn from "#Utils/cn"

const EDGE_CLASSES = {
  left: "left-0 -translate-x-1/2",
  right: "right-0 translate-x-1/2",
}

export type ResizeHandleProps = {
  edge: "left" | "right"
  label: string
  isResizing: boolean
  onMouseDown: (event: React.MouseEvent) => void
  onPointerDown?: (event: React.PointerEvent) => void
  className?: string
}

export const ResizeHandle = ({
  edge,
  label,
  isResizing,
  onMouseDown,
  onPointerDown,
  className,
}: ResizeHandleProps) => (
  <div
    role="separator"
    aria-orientation="vertical"
    aria-label={label}
    onMouseDown={onMouseDown}
    onPointerDown={onPointerDown}
    className={cn(
      "group absolute top-0 z-20 hidden h-full w-6 cursor-col-resize select-none items-center justify-center md:flex",
      EDGE_CLASSES[edge],
      className,
    )}
  >
    <div
      className={cn(
        "h-full w-px bg-edge-default transition-all group-hover:w-1 group-hover:bg-blue-400",
        isResizing && "w-1 bg-blue-500",
      )}
    />
  </div>
)

export default ResizeHandle
